module.exports = __webpack_public_path__ + "img/munic-san-isidro.d51b6c60.png";